export default "__VITE_ASSET__Cns4fThd__"